import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDRESSES_GET_MANY } from 'api/query-keys.ts';
import type { AddressRes } from 'api/swagger';
import type { IWithPagination } from 'types/api-query.ts';

interface IParams extends IWithPagination {
  search?: string;
  isEnabled?: boolean;
}

export const useGetManyAddresses = (params?: IParams) => {
  const { limit = 20, page = 1, search, isEnabled = true } = params || {};

  const qs = new URLSearchParams({ limit: String(limit), page: String(page) });
  if (search) qs.set('filter[search]', search);

  return useQuery<AddressRes[]>({
    queryKey: [ADDRESSES_GET_MANY, { page, limit, search }],
    queryFn: async () => {
      const { data } = await http.get<AddressRes[]>(`/v1/addresses`, {
        params: {
          limit,
          page,
          ...(search ? { 'filter[search]': search } : {}),
        },
      });

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: isEnabled,
    staleTime: 10 * 1000,
    cacheTime: 60 * 1000,
  });
};
